// Gestion de la période de calcul unique avec modale

import { loadPeriods, addPeriod, updatePeriod } from '../services/periodService';
import { updateCalculs } from '../services/calculService';
import { initEventList } from './EventList';

export async function initPeriodSelector() {
  // Récupération des éléments de la modale
  const periodInfo = document.querySelector('.period-info');  // La zone des dates complète
  const periodModal = document.getElementById('period-modal');
  const closePeriodModal = document.getElementById('close-period-modal');
  const cancelPeriodEdit = document.getElementById('cancel-period-edit');
  const editPeriodForm = document.getElementById('edit-period-form');

  // Gestion de l'ouverture de la modale en cliquant sur la zone des dates
  if (periodInfo) {
    periodInfo.addEventListener('click', async function() {
      // Ouvrir la modale
      periodModal.style.display = 'flex';

      // Charger les valeurs actuelles dans la modale
      const periods = await loadPeriods();
      if (periods.length > 0) {
        document.getElementById('modal-start-date').value = periods[0].startDate;
        document.getElementById('modal-end-date').value = periods[0].endDate;
      }
    });
  }

  // Gestion de la fermeture UNIFIÉE
  if (closePeriodModal) {
    closePeriodModal.addEventListener('click', function() {
      closeModal('period-modal');
    });
  }

  if (cancelPeriodEdit) {
    cancelPeriodEdit.addEventListener('click', function() {
      closeModal('period-modal');
    });
  }

  // Fermeture en cliquant en dehors - UNIFIÉE
  periodModal.addEventListener('click', function(event) {
    if (event.target === periodModal) {
      closeModal('period-modal');
    }
  });

  // Gestion du formulaire de modification de période
  if (editPeriodForm) {
    editPeriodForm.addEventListener('submit', async function(event) {
      event.preventDefault();

      const startDate = document.getElementById('modal-start-date').value;
      const endDate = document.getElementById('modal-end-date').value;

      // Validation
      if (!startDate || !endDate) {
        alert('Veuillez spécifier les dates de début et de fin.');
        return;
      }

      if (new Date(startDate) > new Date(endDate)) {
        alert('La date de début doit être antérieure à la date de fin.');
        return;
      }

      try {
        // Récupérer la période existante
        const periods = await loadPeriods();
        if (periods.length > 0) {
          const period = periods[0];
          const updatedPeriod = {
            ...period,
            name: "Période", // Nom fixe
            startDate,
            endDate
          };

          // Mettre à jour
          await updatePeriod(updatedPeriod);
          await selectPeriod(updatedPeriod.id);

          // Fermer la modale
          periodModal.style.display = 'none';

          // Notification subtile
          const notification = document.createElement('div');
          notification.className = 'notification success';
          notification.textContent = 'Période mise à jour avec succès';
          document.body.appendChild(notification);

          setTimeout(() => {
            notification.classList.add('show');
            setTimeout(() => {
              notification.classList.remove('show');
              setTimeout(() => {
                document.body.removeChild(notification);
              }, 300);
            }, 2000);
          }, 100);
        }
      } catch (error) {
        console.error('Erreur lors de la mise à jour de la période:', error);
        alert('Une erreur est survenue lors de la mise à jour de la période.');
      }
    });
  }

  // Charger la période unique
  const periods = await loadPeriods();

  // Si aucune période n'existe, en créer une par défaut
  if (periods.length === 0) {
    await createDefaultPeriod();
  } else {
    // Sélectionner la période existante
    await selectPeriod(periods[0].id);
  }
}

// Le reste du code reste inchangé
async function createDefaultPeriod() {
  // Créer une période par défaut (année en cours)
  const currentYear = new Date().getFullYear();
  const defaultPeriod = {
    name: "Période", // Nom simplifié
    startDate: `${currentYear}-01-01`,
    endDate: `${currentYear}-12-31`
  };

  try {
    const addedPeriod = await addPeriod(defaultPeriod);
    await selectPeriod(addedPeriod.id);
  } catch (error) {
    console.error('Erreur lors de la création de la période par défaut:', error);
  }
}

async function selectPeriod(periodId) {
  try {
    const periods = await loadPeriods();
    const selectedPeriod = periods.find(p => p.id === periodId);

    if (!selectedPeriod) return;

    // Mettre à jour les dates dans l'interface
    const startDateInput = document.getElementById('start-date');
    const endDateInput = document.getElementById('end-date');

    // Mettre également à jour les champs de la modale
    const modalStartDate = document.getElementById('modal-start-date');
    const modalEndDate = document.getElementById('modal-end-date');

    if (startDateInput) startDateInput.value = selectedPeriod.startDate;
    if (endDateInput) endDateInput.value = selectedPeriod.endDate;
    if (modalStartDate) modalStartDate.value = selectedPeriod.startDate;
    if (modalEndDate) modalEndDate.value = selectedPeriod.endDate;

    // Générer l'affichage complet des dates
    updateDateDisplay(selectedPeriod);

    // Rafraîchir l'affichage
    await initEventList();
    await updateCalculs();
  } catch (error) {
    console.error('Erreur lors de la sélection de la période:', error);
  }
}

// Fonction pour mettre à jour l'affichage des dates
function updateDateDisplay(selectedPeriod) {
  const formattedStartDate = formatDisplayDate(selectedPeriod.startDate);
  const formattedEndDate = formatDisplayDate(selectedPeriod.endDate);

  // Générer le texte complet avec "du ... au ..."
  const fullDateText = `<span class="period-start-date">${formattedStartDate}</span> &rarr; <span class="period-end-date">${formattedEndDate}</span>`;

  // Mettre à jour l'affichage principal
  const periodDisplay = document.querySelector('.period-display');
  if (periodDisplay) {
    periodDisplay.innerHTML = fullDateText;
  }

  // Garder la compatibilité avec d'autres éléments si ils existent
  const displayStartDates = document.querySelectorAll('.display-start-date');
  const displayEndDates = document.querySelectorAll('.display-end-date');
  const headerStartDates = document.querySelectorAll('.period-start-date');
  const headerEndDates = document.querySelectorAll('.period-end-date');

  displayStartDates.forEach(el => el.textContent = formattedStartDate);
  displayEndDates.forEach(el => el.textContent = formattedEndDate);
  headerStartDates.forEach(el => el.textContent = formattedStartDate);
  headerEndDates.forEach(el => el.textContent = formattedEndDate);
}

// Fonction pour formater les dates en format lisible pour l'affichage
function formatDisplayDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
}
